<p-tabs value="{{activeTabIndex}}">
  <p-tablist style="display: flex; align-items: center;" class="container-style px-0 py-1">
    <p-tab (click)="handleTabChange(0)" value="0">Consulta General</p-tab>
    <p-tab (click)="handleTabChange(1)" value="1">Consulta Detalle</p-tab>
    <p-tab (click)="handleTabChange(2)" value="2">Consulta Facturas</p-tab>
    <app-custom-button class="widthBtns" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'" [width]="'5.5rem'"
      [severity]="'success'" [variant]="undefined" (onClick)="newSuspension()"></app-custom-button>
  </p-tablist>
  <p-tabpanels class="container-style mt-2">
    <p-tabpanel value="0">
      <app-custom-indicators [charts]="indicatorCharts" [loading]="loadingIndicators"></app-custom-indicators>
      <app-custom-table [showExport]="true" [showRecover]="true" [headers]="generalHeader" [data]="generalData"
        [actions]="tableActions" [previousFilters]="filters" [filterPersistentKey]="'suspension'"
        (onRecoverData)="getAllSuspensionsWithPagination()" (onPageChange)="onPageChange($event)"
        (onReload)="getIndicatorsForGeneralConsultation()" (onFilterChange)="onFilterChange($event)"
        (onExport)="onExport()" (onAction)="onAction($event)"></app-custom-table>
    </p-tabpanel>
    <p-tabpanel value="1">
      <app-custom-table [showExport]="true" [showRecover]="true" [headers]="detailHeader" [data]="detailData"
        [actions]="tableActions" [previousFilters]="filters" [filterPersistentKey]="'suspension'"
        (onRecoverData)="getAllSuspensionDetailsWithPagination()" (onPageChange)="onPageChange($event)"
        (onFilterChange)="onFilterChange($event)" (onExport)="onExport()"
        (onAction)="onAction($event)"></app-custom-table>
    </p-tabpanel>
    <p-tabpanel value="2">
      <app-custom-table [showExport]="true" [showRecover]="true" [headers]="invoiceHeader" [data]="invoiceData"
        [actions]="tableActions" [previousFilters]="filters" [filterPersistentKey]="'suspension'"
        (onRecoverData)="getAllInvoiceForSuspensionsWithPagination()" (onPageChange)="onPageChange($event)"
        (onFilterChange)="onFilterChange($event)" (onExport)="onExport()"
        (onAction)="onAction($event)"></app-custom-table>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>